<template>
    <modal
        name="modal-error"
        height="auto"
    >
        <div class="container">
            <div class="img-wrapper">
                <img class="img" src="../../assets/images/documents.svg"/>
            </div>
            <div class="body-title-wrapper">
                <div class="body-title">Superaste el límite de documentos adjuntos</div>
            </div>
            <div class="body-content-wrapper">
                <div class="body-content">Recuerda que puedes adjuntar máximo {{max}} documentos por cada producto.</div>
            </div>
            <div class="buttons-wrapper">
                <button @click="close" class="primary-button-xs">Entendido</button>
            </div>
        </div>
    </modal>
</template>
<script>

export default {
    name:"modal-error",
    props: {
      max: String
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
.container{
    padding: 75px 35px 0 35px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.14);
    height: auto;
}
.img-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.img{
    width: 180px;
    height: 180px;
}
.body-title-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.body-content-wrapper {
    justify-content: center;
    margin-bottom: 30px;
}
.body-content {
    font-size: 16px;
    color: $bold-grey;
    text-align: center;
    margin-bottom: 40px;
}
.body-title {
    font-size: 20px;
    color: #000000;
}
.buttons-wrapper{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}
</style>